import { useTranslation } from "react-i18next"

import { ChevronUp, Settings2, Sparkles } from "@/components/icons"
import { Badge } from "@/components/ui/badge"

export function DemoDeepToggle() {
  const { t } = useTranslation("", { keyPrefix: "training.ai-agents.helloai.deep.toggle" })

  return (
    <div className="w-full sm:max-w-md">
      <div className="bg-background relative rounded-xl border p-2 shadow-sm">
        <div className="flex items-center gap-2 px-1 py-1">
          <Settings2 className="text-muted-foreground size-4" />
          <span className="text-muted-foreground text-xs">
            {t("composer_hint", "AI Mode menu in the Explorer footer")}
          </span>
          <ChevronUp className="text-muted-foreground ml-auto size-3.5" />
        </div>

        <div className="border-border mt-2 space-y-1 rounded-lg border p-2">
          <p className="text-muted-foreground px-1 text-[10px] font-medium tracking-wide uppercase">
            {t("section_label", "AI Mode")}
          </p>
          <div className="bg-primary/10 text-primary flex items-center gap-2 rounded-md px-2 py-1.5">
            <Sparkles className="size-4" />
            <span className="text-sm font-semibold">{t("deep_label", "Deep")}</span>
            <Badge className="ml-1 h-4 px-1.5 text-[10px] font-medium" variant="secondary">
              {t("beta_badge", "Beta")}
            </Badge>
            <span className="bg-primary ml-auto inline-block h-2 w-2 rounded-full" />
          </div>
        </div>
      </div>
    </div>
  )
}
